import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddEditVesselRatePerHourDialogComponent } from './add-edit-vessel-rate-per-hour-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TextMaskModule } from 'angular2-text-mask';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    TextMaskModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
  ],
  declarations: [AddEditVesselRatePerHourDialogComponent],
  entryComponents: [AddEditVesselRatePerHourDialogComponent],
  exports: [AddEditVesselRatePerHourDialogComponent],
  providers: [],
})
export class AddEditVesselRatePerHourDialogModule {}
